import React, { useEffect, useState } from "react";
import "../../assets/styles/components/status.scss";
import { useDispatch, useSelector } from "react-redux";
import { findValue, updateInput } from "../Input/functions";

export default function Status(props) {
    const { input } = props;
    const dispatch = useDispatch();
    const formData = useSelector((state) => state).formReducer;
    const editItem = useSelector((state) => state.formReducer.editItem);
    const activeIndex = useSelector((state) => state).formReducer.activeIndex;
    const onChange = props?.onChange
    const defaultValue = input.defaultValue ?? true;

    const [checked, setChecked] = useState(defaultValue);

    useEffect(() => {
        updateValue();
    }, []);

    useEffect(() => {
        updateValue();
    }, [activeIndex, editItem]);

    const updateValue = () => {
        const value = findValue(
            formData,
            input.formType,
            input.name,
            editItem ? editItem[input.name] : defaultValue
        );

        const trueValues = [true, "true", 1, "1"];
        const checked = trueValues.includes(value);
        setChecked(checked);
    };

    const setValue = () => {

        setChecked(!checked);
        updateInput(dispatch, input.formType, input.name, !checked, input.primary);
        if (onChange) {
            onChange(!checked)
        }
    };
    return (
        <div className="row">
            <div
                className="col-lg-12 col-md-12 col-sm-12 col-xs-12"
                style={props.input.style ? props.input.style : null}
            >
                {input.showLabel === false ? null : <div className="status-title">وضعیت</div>}
                <div
                    className={
                        checked && !input.disabled
                            ? `box-status-component-active animation ${input.showLabel === false ? "mt-2" : null}`
                            : `box-status-component-inactive animation ${input.showLabel === false ? "mt-2" : null}`
                    }
                    onClick={() => setValue()}
                >
                    <div className="icon-switch" />
                    {!input.disabled ? (
                        <div className="text-switch-status">
                            {input.showLabel === false
                                ? checked === true
                                    ? "بله"
                                    : "خیر"
                                : checked === true
                                    ? "فعال"
                                    : "غیر فعال"}
                        </div>
                    ) : null}
                </div>
            </div>
        </div>
    );
}
